(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["daTheme"] = factory();
	else
		root["daTheme"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	/*----------------------------------------------------------------------------------
	 ----------------------------------------------------------------------------------*/
	// DA THEME
	//
	// Organization:
	// * Private Functions and Definitions
	// * Public Functions and Definitions
	// * Config Theme Elements Constructors
	/*----------------------------------------------------------------------------------
	 ----------------------------------------------------------------------------------*/
	module.exports = (function () {

	  var theme = {};


	  /*----------------------------------------------------------------------------------
	   ----------------------------------------------------------------------------------*/
	  /*----------------------------------------------------------------------------------
	   // PRIVATE FUNCTION and DEFINITIONS
	   ----------------------------------------------------------------------------------*/
	  /*----------------------------------------------------------------------------------
	   ----------------------------------------------------------------------------------*/

	  var largeIndexMap = {
	    0: [],
	    1: [[0, 3]],
	    2: [[0, 3], [1, 1]],
	    3: [[0, 3], [1, 1], [2, 3]],
	    4: [[0, 3], [1, 1], [2, 2], [2, 4]],
	    5: [[0, 3], [1, 2], [1, 4], [2, 2], [2, 4]],
	    6: [[0, 2], [0, 4], [1, 2], [1, 4], [2, 2], [2, 4]],
	    7: [[0, 2], [0, 4], [1, 2], [1, 4], [2, 1], [2, 4], [2, 3]],
	    8: [[0, 2], [0, 4], [1, 1], [1, 4], [1, 3], [2, 1], [2, 4], [2, 3]],
	    9: [[0, 1], [0, 4], [0, 3], [1, 1], [1, 4], [1, 3], [2, 1], [2, 4], [2, 3]],
	    10: [[0, 1], [0, 4], [0, 3], [1, 1], [1, 4], [1, 3], [2, 0], [2, 3], [2, 1], [2, 4]],
	    11: [[0, 1], [0, 4], [0, 3], [1, 0], [1, 3], [1, 1], [1, 4], [2, 0], [2, 3], [2, 1], [2, 4]],
	    12: [[0, 0], [0, 3], [0, 1], [0, 4], [1, 0], [1, 3], [1, 1], [1, 4], [2, 0], [2, 3], [2, 1], [2, 4]],
	    13: [[0, 0], [0, 3], [0, 1], [0, 4], [1, 0], [1, 3], [1, 1], [1, 4], [2, 0], [2, 3], [2, 1], [2, 4], [2, 2]],
	    14: [[0, 0], [0, 3], [0, 1], [0, 4], [1, 0], [1, 3], [1, 1], [1, 4], [1, 2], [2, 0], [2, 3], [2, 1], [2, 4], [2, 2]],
	    15: [[0, 0], [0, 3], [0, 1], [0, 4], [0, 2], [1, 0], [1, 3], [1, 1], [1, 4], [1, 2], [2, 0], [2, 3], [2, 1], [2, 4], [2, 2]],
	    16: [[0, 0], [0, 3], [0, 1], [0, 4], [0, 2], [1, 0], [1, 3], [1, 1], [1, 4], [1, 2], [2, 0], [2, 3], [2, 1], [2, 4], [2, 2], [2, 5]],
	    17: [[0, 0], [0, 3], [0, 1], [0, 4], [0, 2], [1, 0], [1, 3], [1, 1], [1, 4], [1, 2], [1, 5], [2, 0], [2, 3], [2, 1], [2, 4], [2, 2], [2, 5]],
	    18: [[0, 0], [0, 3], [0, 1], [0, 4], [0, 2], [0, 5], [1, 0], [1, 3], [1, 1], [1, 4], [1, 2], [1, 5], [2, 0], [2, 3], [2, 1], [2, 4], [2, 2], [2, 5]]
	  };


	  //**********************************************************************************
	  //**********************************************************************************
	  function getPrimaryColorForSeriesCountFrom2DThemeColors(seriesCount, primaryColors) {
	    var seriesColors = primaryColors;

	    if (seriesColors === null || seriesColors === undefined || seriesColors.length < 1) return null;

	    var colors = [];

	    if (seriesCount <= 18) {
	      var colorIndexes = largeIndexMap[seriesCount];
	      var i = 0;

	      for (; i < colorIndexes.length; i++) {
	        colors.push(seriesColors[colorIndexes[i][0]][colorIndexes[i][1]])
	      }
	    }
	    else //More than 18
	    {
	      var hueIndex;
	      var tmpShadeIndex = 0;
	      var shadeOffset = 3;

	      for (hueIndex = 0; hueIndex < seriesColors.length && colors.length < seriesCount; hueIndex++) {
	        tmpShadeIndex = 0;
	        for (; tmpShadeIndex + shadeOffset < seriesColors[hueIndex].length && colors.length < seriesCount; tmpShadeIndex++) {
	          colors.push(seriesColors[hueIndex][tmpShadeIndex]);

	          if (colors.length < seriesCount) {
	            colors.push(seriesColors[hueIndex][tmpShadeIndex + shadeOffset]);
	          }
	        }
	      }
	    }

	    return colors;
	  }


	  //**********************************************************************************
	  //**********************************************************************************
	  function getSecondaryColorForSeriesCountFrom2DThemeColors(seriesCount, primaryColors) {
	    var seriesColors = primaryColors;

	    if (seriesColors === null || seriesColors === undefined || seriesColors.length < 1) return null;

	    var colors = [];
	    var maxShadeIndex;
	    var secondShadeOffset;


	    if (seriesCount <= 18) {
	      var i = 0;
	      var colorIndexes = largeIndexMap[seriesCount];
	      maxShadeIndex = seriesColors[0].length - 1;
	      secondShadeOffset = maxShadeIndex - 1;

	      for (; i < colorIndexes.length; i++) {
	        colors.push(seriesColors[colorIndexes[i][0]][(colorIndexes[i][1] + secondShadeOffset > maxShadeIndex ? 0 : colorIndexes[i][1] + secondShadeOffset)])
	      }
	    }
	    else //More than 18
	    {
	      var tmpShadeIndex = 0;
	      var shadeOffset = 3;

	      maxShadeIndex = seriesColors[0].length - 1; // ASSUMING that there are an equal # of shades in each Hue.
	      secondShadeOffset = maxShadeIndex - 1;

	      for (var hueIndex = 0; hueIndex < seriesColors.length && colors.length < seriesCount; hueIndex++) {
	        tmpShadeIndex = 0;
	        for (; tmpShadeIndex + shadeOffset < seriesColors[hueIndex].length && colors.length < seriesCount; tmpShadeIndex++) {
	          colors.push(seriesColors[hueIndex][(tmpShadeIndex + secondShadeOffset > maxShadeIndex ? 0 : tmpShadeIndex + secondShadeOffset)]);

	          if (colors.length < seriesCount) {
	            colors.push(seriesColors[hueIndex][(tmpShadeIndex + shadeOffset + secondShadeOffset > maxShadeIndex ? 0 : tmpShadeIndex + shadeOffset + secondShadeOffset)]);
	          }
	        }
	      }
	    }

	    return colors;
	  }


	  //**********************************************************************************
	  //**********************************************************************************
	  function primarySeriesColorsIs2D(primaryColors) {
	    return primaryColors !== undefined && primaryColors.length > 0 && typeof primaryColors[0] === 'object';
	  }


	  /*----------------------------------------------------------------------------------
	   ----------------------------------------------------------------------------------*/
	  /*----------------------------------------------------------------------------------
	   // PUBLIC FUNCTIONS and DEFINITIONS
	   ----------------------------------------------------------------------------------*/
	  /*----------------------------------------------------------------------------------
	   ----------------------------------------------------------------------------------*/

	  theme.domoColors = [
	    //Shade 1,  Shade 2,  Shade 3,  Shade 4,  Shade 5,  Shade 6
	    ['#D9EBFD', '#B7DAF5', '#90c4e4', '#73B0D7', '#4E8CBA', '#31689B'],//Blues
	    ['#DDF4BA', '#BBE491', '#A0D771', '#80C25D', '#559E38', '#387B26'],//Greens
	    ['#FDECAD', '#FCCF84', '#FBAD56', '#FB8D34', '#E45621', '#A43724'],//Oranges
	    ['#F3E4FE', '#DDC8EF', '#C5ACDE', '#B391CA', '#8F6DC0', '#7940A1'],//Purples
	    ['#FCD7E6', '#FBB6DD', '#F395CD', '#EE76BF', '#CF51AC', '#A62A92'],//Pink
	    ['#D8F4DE', '#ABE4CA', '#8DD5BE', '#68BEA8', '#46998A', '#227872'],//Teals
	    ['#FDDDDD', '#FCBCB7', '#FD9A93', '#FD7F76', '#e45850', '#c92e25'] //Reds
	  ];

	  /*----------------------------------------------------------------------------------
	   // getPrimaryColorsForNumberOfSeries
	   ----------------------------------------------------------------------------------*/
	  theme.getPrimaryColorsForNumberOfSeries = function (number, primaryColors) {
	    if (primarySeriesColorsIs2D(primaryColors)) {
	      return getPrimaryColorForSeriesCountFrom2DThemeColors(number, primaryColors);
	    }
	    else {
	      return primaryColors.slice(0, number);
	    }
	  };


	  /*----------------------------------------------------------------------------------
	   //getSecondaryColorsForNumberOfSeries
	   ----------------------------------------------------------------------------------*/
	  theme.getSecondaryColorsForNumberOfSeries = function (number, primaryColors, secondaryColors) {
	    if (primarySeriesColorsIs2D(primaryColors)) {
	      return getSecondaryColorForSeriesCountFrom2DThemeColors(number, primaryColors);
	    }
	    else {
	      return secondaryColors.slice(0, number);
	    }
	  };


	  /*----------------------------------------------------------------------------------
	   ----------------------------------------------------------------------------------*/
	  /*----------------------------------------------------------------------------------
	   // THEME COMPONENTS
	   ----------------------------------------------------------------------------------*/
	  /*----------------------------------------------------------------------------------
	   ----------------------------------------------------------------------------------*/


	  /*--------------------------------------------------------------------------------------
	   // THEME CONFIG ELEMENT CONSTRUCTOR FUNCTIONS
	   //
	   // Functions that will return the value of each theme config element.
	   //
	   // Example:
	   // _Chart.config = {generalFillGoodColor:da.theme.themeElements.generalFillGoodColor()}
	   ---------------------------------------------------------------------------------------*/
	  theme.themeElements = {

	    //----------------------------------------------------------------------------------
	    // General
	    //----------------------------------------------------------------------------------

	    generalFillPrimaryColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalFillPrimaryColor',
	        name: options.name || 'General Fill Primary Color',
	        description: options.description || 'The primary fill color for each gauge',
	        category: options.category || 'General Fills',
	        value: '#73B0D7',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    generalFillSecondaryColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalFillSecondaryColor',
	        name: options.name || 'General Fill Secondary Color',
	        description: options.description || 'The secondary fill color for each gauge',
	        category: options.category || 'General Fills',
	        value: '#DAEAF8',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    generalBackgroundColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalBackgroundColor',
	        name: options.name || 'General Background Color',
	        description: options.description || 'Background color',
	        category: options.category || 'General Fill',
	        value: '#FFFFFF',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    generalFillGoodColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalFillGoodColor',
	        name: options.name || 'General Fill Good Color',
	        description: options.description || 'Color meant to indicate something good',
	        category: options.category || 'General Fill',
	        value: '#80C25D',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    generalFillBadColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalFillBadColor',
	        name: options.name || 'General Fill Bad Color',
	        description: options.description || 'Color meant to indicate something bad',
	        category: options.category || 'General Fill',
	        value: '#E4584F',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    generalFillNeutralColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalFillNeutralColor',
	        name: options.name || 'General Fill Neutral Color',
	        description: options.description || 'Color meant to indicate something that is neither good nor bad',
	        category: options.category || 'General Fill',
	        value: '#E5E5E5',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    generalStrokeGoodColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalStrokeGoodColor',
	        name: options.name || 'General Stroke Good Color',
	        description: options.description || 'Stroke color meant to indicate something good',
	        category: options.category || 'General Fill',
	        value: '#559E38',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    generalStrokeBadColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalStrokeBadColor',
	        name: options.name || 'General Stroke Bad Color',
	        description: options.description || 'Stroke color meant to indicate something bad',
	        category: options.category || 'General Fill',
	        value: '#C92E25',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    generalStrokeNeutralColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalStrokeNeutralColor',
	        name: options.name || 'General Stroke Neutral Color',
	        description: options.description || 'Stroke color meant to indicate something that is neither good nor bad',
	        category: options.category || 'General Fill',
	        value: '#d7d9da',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },

	    generalNotFilledColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalNotFilledColor',
	        name: options.name || 'General Not Filled Color',
	        description: options.description || 'Color used to indicate no data',
	        category: options.category || 'General Fill',
	        value: '#E4E5E5',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },

	    generalWashoutColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalWashoutColor',
	        name: options.name || 'General Washout Color',
	        description: options.description || 'Color used to indicate elements that are not being highlighted',
	        category: options.category || 'General Fill',
	        value: '#E4E5E5',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },

	    generalSeparatorColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'generalSeparatorColor',
	        name: options.name || 'General Separator Color',
	        description: options.description || 'Color for element separators',
	        category: options.category || 'General Fill',
	        value: '#FFFFFF',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },

	    pastelFillGoodColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'pastelFillGoodColor',
	        name: options.name || 'Pastel Fill Good Color',
	        description: options.description || 'Soft-hued color meant to indicate something good',
	        category: options.category || 'General Fill',
	        value: '#91D0BC',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },

	    pastelFillBadColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'pastelFillBadColor',
	        name: options.name || 'Pastel Fill Bad Color',
	        description: options.description || 'Soft-hued color meant to indicate something bad',
	        category: options.category || 'General Fill',
	        value: '#F27E79',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },


	    //----------------------------------------------------------------------------------
	    // Axis
	    //----------------------------------------------------------------------------------
	    axesLineColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'axesLineColor',
	        name: options.name || 'Axes Line Color',
	        description: options.description || 'Color of all lines found in the axes',
	        category: options.category || 'Axes',
	        value: '#E3E3E3',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      };
	    },
	    axesLabelColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'axesLabelColor',
	        name: options.name || 'Axes Label Color',
	        description: options.description || 'Color of all the labels on the axes',
	        category: options.category || 'Axes',
	        value: '#888',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    axesLabelSize: function (options) {
	      options = options || {};
	      return {
	        theme: 'axesLabelSize',
	        name: options.name || 'Axes Label Size',
	        description: options.description || 'Size of the labels',
	        category: options.category || 'Axes',
	        value: 11,
	        type: 'number',
	        units: 'px',
	        options: undefined,
	      }
	    },
	    axesLabelFontFamily: function (options) {
	      options = options || {};
	      return {
	        theme: 'axesLabelFontFamily',
	        name: options.name || 'Axes Label Font Family',
	        description: options.description || 'Font family for axes labels',
	        category: options.category || 'Axes',
	        value: 'Open Sans',
	        type: 'string',
	        units: undefined,
	        options: undefined,
	      }
	    },


	    //----------------------------------------------------------------------------------
	    // GaugeFills
	    //----------------------------------------------------------------------------------
	    gaugeFillPrimaryColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'gaugeFillPrimaryColor',
	        name: options.name || 'Gauge Fill Primary Color',
	        description: options.description || 'The primary fill color for each gauge',
	        category: options.category || 'Gauge Fills',
	        value: '#73B0D7',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    gaugeFillSecondaryColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'gaugeFillSecondaryColor',
	        name: options.name || 'Gauge Fill Secondary Color',
	        description: options.description || 'The secondary fill color for each gauge',
	        category: options.category || 'Gauge Fills',
	        value: '#DAEAF8',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    gaugeFillNotFilledColor: function (options) {
	      console.warn('Config Theme Element "gaugeFillNotFilledColor" is deprecated. Use generalNotFilledColor');
	      return da.theme.te.generalNotFilledColor(options);
	    },
	    gaugeFillSeparatorColor: function (options) {
	      console.warn('Config Theme Element "gaugeFillSeparatorColor" is deprecated. Use generalSeparatorColor');
	      return da.theme.te.generalSeparatorColor(options);
	    },


	    //----------------------------------------------------------------------------------
	    // GaugeStroke
	    //----------------------------------------------------------------------------------
	    gaugeStrokePrimaryColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'gaugeStrokePrimaryColor',
	        name: options.name || 'Gauge Stroke Primary Color',
	        description: options.description || 'The primary stroke color of each filled element on a gauge',
	        category: options.category || 'Gauge Stroke',
	        value: '#73B0D7',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    gaugeStrokeSecondaryColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'gaugeStrokeSecondaryColor',
	        name: options.name || 'Gauge Stroke Secondary Color',
	        description: options.description || 'The secondary stroke color for each gauge',
	        category: options.category || 'Gauge Stroke',
	        value: '#DAEAF8',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    gaugeStrokeNotFilledColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'gaugeStrokeNotFilledColor',
	        name: options.name || 'Gauge Stroke Not Filled Color',
	        description: options.description || 'Stroke color on an unfilled gauge',
	        category: options.category || 'Gauge Stroke',
	        value: '#E4E5E5',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },


	    /*----------------------------------------------------------------------------------
	     //ChartSeriesColors (3):
	     ----------------------------------------------------------------------------------*/
	    chartPrimarySeriesColors: function (options) {
	      options = options || {};
	      return {
	        theme: 'chartPrimarySeriesColors',
	        name: options.name || 'Chart Primary Series Colors',
	        description: options.description || 'The primary colors used to represent series data',
	        category: options.category || 'Chart Series Colors',
	        value: theme.domoColors,
	        type: 'colorArray',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    chartSecondarySeriesColors: function (options) {
	      options = options || {};
	      return {
	        theme: 'chartSecondarySeriesColors',
	        name: options.name || 'Chart Secondary Series Colors',
	        description: options.description || 'The secondary colors used to represent series data',
	        category: options.category || 'Chart Series Colors',
	        value: ['#4E8CBA', '#D9EBFD', '#31689B', '#D9EBFD', '#D9EBFD', '#559E38', '#DDF4BA', '#387B26', '#DDF4BA', '#DDF4BA', '#E45621', '#FDECAD', '#A43724', '#FDECAD', '#FDECAD', '#FDECAD'],
	        type: 'colorArray',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    chartDivergentColors: function (options) {
	      options = options || {};
	      return {
	        theme: 'chartDivergentColors',
	        name: options.name || 'Chart Divergent Colors',
	        description: options.description || 'Chart series colors',
	        category: options.category || '',
	        value: ['#336088', '#71A7C7', '#B7D7E6', '#D8EBF3', '#FFFFFF', '#F7DAD7', '#EFB7B1', '#E37872', '#B53230'],
	        type: 'colorArray',
	        units: undefined,
	        options: undefined,
	      }
	    },


	    /*----------------------------------------------------------------------------------
	     //Tooltip (2):
	     ----------------------------------------------------------------------------------*/
	    tooltipBackgroundColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'tooltipBackgroundColor',
	        name: options.name || 'Tooltip Background Color',
	        description: options.description || 'Background color of the tooltip',
	        category: options.category || 'Tooltip',
	        value: '#555555',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    tooltipTextColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'tooltipTextColor',
	        name: options.name || 'Tooltip Text Color',
	        description: options.description || 'Color of the tooltip text',
	        category: options.category || 'Tooltip',
	        value: '#FFFFFF',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },


	    /*----------------------------------------------------------------------------------
	     //Text (3):
	     ----------------------------------------------------------------------------------*/
	    textFontFamily: function (options) {
	      options = options || {};
	      return {
	        theme: 'textFontFamily',
	        name: options.name || 'Text Font Family',
	        description: options.description || '',
	        category: options.category || 'Text',
	        value: 'Open Sans',
	        type: 'string',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    textColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'textColor',
	        name: options.name || 'Text Color',
	        description: options.description || '',
	        category: options.category || 'Text',
	        value: '#333',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    textSize: function (options) {
	      options = options || {};
	      return {
	        theme: 'textSize',
	        name: options.name || 'Text Size',
	        description: options.description || '',
	        category: options.category || 'Text',
	        value: 12,
	        type: 'number',
	        units: 'px',
	        options: undefined,
	      }
	    },
	     accentTextColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'accentTextColor',
	        name: options.name || 'Accent Text Color',
	        description: options.description || 'Color for accent text',
	        category: options.category || 'Text',
	        value: '#f68c35',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    fontWeight: function (options) {
	      options = options || {};
	      return {
	        theme: 'fontWeight',
	        name: options.name || 'Font Weight',
	        description: options.description || 'General text font weight. Note: Not all weights are supported by every font family.',
	        category: options.category || 'Text',
	        value: {name:'400 - Regular', value:400},
	        type: 'select',
	        options: [
	          {name:'100', value:100},
	          {name:'200', value:200},
	          {name:'300 - Light'  , value:300},
	          {name:'400 - Regular', value:400},
	          {name:'500', value:500},
	          {name:'600', value:600},
	          {name:'700 - Bold'   , value:700},
	          {name:'800', value:800},
	          {name:'900', value:900}
	        ]
	      }
	    },

	    /*----------------------------------------------------------------------------------
	     //ChartLabels (1):
	     ----------------------------------------------------------------------------------*/
	    chartLabelColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'chartLabelColor',
	        name: options.name || 'Chart Label Color',
	        description: options.description || 'Color for chart labels',
	        category: options.category || 'Chart Labels',
	        value: '#888888',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },


	    /*----------------------------------------------------------------------------------
	     //Maps (4):
	     ----------------------------------------------------------------------------------*/
	    mapRangeColors: function (options) {
	      options = options || {};
	      return {
	        theme: 'mapRangeColors',
	        name: options.name || 'Map Range Colors',
	        description: options.description || 'Range of colors for the map',
	        category: options.category || 'Maps',
	        value: ['#FDECAD', '#FCCF84', '#FBAD56', '#FB8D34', '#E45621', '#A43724'],
	        type: 'colorArray',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    mapNoDataColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'mapNoDataColor',
	        name: options.name || 'Map No Data Color',
	        description: options.description || 'Color for an element that has no data on the map',
	        category: options.category || 'Maps',
	        value: '#D8D8D9',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    mapBorderColor: function (options) {
	      options = options || {};
	      return {
	        theme: 'mapBorderColor',
	        name: options.name || 'Map Border Color',
	        description: options.description || 'Color for the borders around each section of the map',
	        category: options.category || 'Maps',
	        value: '#FFFFFF',
	        type: 'color',
	        units: undefined,
	        options: undefined,
	      }
	    },
	    mapBorderWeight: function (options) {
	      options = options || {};
	      return {
	        theme: 'mapBorderWeight',
	        name: options.name || 'Map Border Weight',
	        description: options.description || 'Stroke width for each land divider',
	        category: options.category || 'Maps',
	        value: 1,
	        type: 'number',
	        units: 'px',
	        options: undefined,
	      }
	    },
	    mapBorderWeigh: function (options) {
	      console.warn('Config Theme Element "mapBorderWeigh" is deprecated. Use mapBorderWeight');
	      return da.theme.te.mapBorderWeight(options);
	    }

	  };
	  theme.te = theme.themeElements;

	  return theme;
	}());


/***/ }
/******/ ])
});
;


/*****************
 ** WEBPACK FOOTER
 ** ./~/da-theme/dist/bundle.js
 ** module id = 6
 ** module chunks = 0
 **/